<div fxLayout="row">
  <a class="prime-phone link-btn-action" [href]="phoneLink" *ngIf="!!(phoneNumber)">
    <div class="primary-phone-icon icon">
      <p *ngIf="(isMobile$ | async)">&nbsp;</p>
      <p *ngIf="!(isMobile$ | async)">{{phoneNumber}}</p>
    </div>
  </a>
  <a class="security-info link-btn-action" href="#" (click)="openDialog($event)" fxLayout="row">
    <div class="security-icon icon">
      <p *ngIf="!(isMobile$ | async)">Secure Site</p>
    </div>
  </a>
</div>
